import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FileUploaderWidget } from '@geoanalitika/widgets';
import { MapComponent } from 'shared/components';
import { IBaseLayer } from 'shared/interfaces';
import { Project } from '../../classes';
import { ProjectService } from '../../services';

@Component({
  selector: 'geo-project-form',
  templateUrl: 'project-form.component.html',
  styleUrls: ['./project-form.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectFormComponent implements OnInit {
  @ViewChild('uploader') uploader: FileUploaderWidget;
  @ViewChild('map')
  set map(map: MapComponent) {
    if (map) {
      this._map = map;
      this.selectBaseLayer();
    }
  }

  get map() {
    return this._map;
  }

  @Input() project: Project;
  @Input() baseMaps: IBaseLayer[] = [];
  @Input() dirty = false;

  @Output() save = new EventEmitter();
  @Output() cancel = new EventEmitter();
  @Output() error: EventEmitter<string> = new EventEmitter();

  allowedFormats = ['png', 'jpg', 'jpeg'];
  maxSize = 10485760; // 10Mb
  showMap = false;

  private _map: MapComponent;

  constructor(private ref: ChangeDetectorRef, private projectService: ProjectService) {}

  ngOnInit() {
    // таймаут перед загрузкой карты в рамках борьбы c #119 п.4
    setTimeout(() => {
      this.showMap = true;
      this.ref.markForCheck();
    }, 250);
  }

  selectBaseLayer() {
    this.map.changeBaseLayer(this.project.base_map);
  }

  addImage(files: File[]) {
    this.project.preview = files[0];
  }

  clearExtent() {
    this.project.extent = '';
  }

  clearPreview() {
    this.project.preview = null;
    this.uploader.reset();
  }

  saveExtent(wkt: string) {
    this.project.extent = wkt;
  }

  getFileName() {
    if (!this.project.preview) {
      return;
    }
    if (typeof this.project.preview === 'string') {
      return this.project.preview.split('/').pop();
    }
    return this.project.preview.name;
  }
}
